export const ACCOUNT_ENDPOINTS = {
    defaultBankAccount: '/user/default-bank-account',
    userProfile: '/user/profile',
};
